import * as React from 'react';

import { Pack, canManagePack } from './shared';

const ActivitiesCell = ({ children, onManageActivities, pack }: { children: React.ReactNode, onManageActivities?: () => void, pack: Pack }) => (
  <div className="activities-cell">
    {children}
    {onManageActivities && canManagePack(pack) && (
      <button className="quill-button extra-small outlined grey focus-on-light" onClick={onManageActivities} type="button">Edit dates &amp; activities</button>
    )}
  </div>
)

export default ActivitiesCell
